import { NAVIGATION_ROOT } from '../../../components/bearing-search/api/api';
import { FittingPracticeNavigationItem } from '../../../components/bearing-search/types/types';
import { SelectOption } from '../../types/types';
import { generateId } from '../../utils/engineering-tools';
import { FittingPracticeNavigationMap } from './FittingForm';

export const getFittingPracticeNavigationOptions = ( list: FittingPracticeNavigationItem[] ): {
	id: string;
	label: string;
	options: SelectOption<string>[];
} => {
	if ( list.length === 0 ) {
		return {
			id: '',
			label: '',
			options: [],
		};
	}

	return {
		id: `${ list[ 0 ]?.categoryId }`,
		label: list[ 0 ]?.categoryLabel,
		options: list.map( ( item ) => {
			const { categoryLabel, categoryDescription } = item;

			const option: SelectOption<string> = {
				id: generateId( `${ categoryLabel } ${ categoryDescription }` ),
				value: categoryDescription,
				label: categoryDescription,
			};

			return option;
		} ),
	};
};

export const getFittingPracticeNavigationMap = ( navigation: FittingPracticeNavigationItem[] ): [FittingPracticeNavigationMap, FittingPracticeNavigationMap] => {
	const innerNavigation = new Map<string, FittingPracticeNavigationItem[]>();
	const outerNavigation = new Map<string, FittingPracticeNavigationItem[]>();

	navigation.forEach( ( item ) => {
		const id = item.isRoot ? NAVIGATION_ROOT : `${ item.categoryId }`;

		if ( item.componentType === 'IR' ) {
			if ( ! innerNavigation.has( id ) ) {
				innerNavigation.set( id, [] );
			}

			innerNavigation.get( id )?.push( item );
		} else {
			if ( ! outerNavigation.has( id ) ) {
				outerNavigation.set( id, [] );
			}

			outerNavigation.get( id )?.push( item );
		}
	} );

	return [ innerNavigation, outerNavigation ];
};
